import CurrentReportsService from '../services/CurrentReports.service';
import { SETTINGS } from 'common/consts/kentico';

import { observable, action, decorate } from 'mobx';

class CurrentReportsStore {
  latestSearches = new Map();
  otherCurrentReports = [];

  latestState = {
    data: [],
    page: 1,
    isExploited: false,
    category: '',
    publishYear: {
      value: ''
    }
  };

  async fetchLatestCurrentReports(criteria) {
    const { limit = SETTINGS.DEFAULT_LIMIT, page = 1, category } = criteria;
    const publishYear = criteria.publishYear.value;

    const cacheKey = JSON.stringify({
      category,
      publishYear,
      page,
      limit
    });

    if (this.latestState.data.length) {
      return {
        isExploited: this.latestState.isExploited,
        data: this.latestState.data,
        category: this.latestState.category,
        publishYear: this.latestState.publishYear
      };
    }

    const cachedSearch = this.latestSearches.get(cacheKey);

    if (cachedSearch) {
      return cachedSearch;
    }

    try {
      const items = await CurrentReportsService.fetchCurrentReports({
        limit,
        page,
        category,
        publishYear
      });

      if (items.isEmpty) {
        return {
          isExploited: true,
          data: []
        };
      }

      const isNextPage = !!items.pagination.nextPage;

      const data = {
        isExploited: !isNextPage,
        data: items.items
      };

      this.latestSearches.set(cacheKey, data);

      return data;
    } catch (e) {
      console.error('Failed to fetch featured CurrentReports data', e);
      return null;
    }
  }

  /**
   * Get CurrentReports news item by id
   * @param { number } id
   * @returns { CurrentReportsItem } Prommise resolved CurrentReports news item
   */
  async getCurrentReportsItemById(id) {
    try {
      const items = await CurrentReportsService.getCurrentReportsItemById(id);
      return items.isEmpty ? null : items.items[0];
    } catch (e) {
      console.error('Failed to fetch current reports news item data');
      return null;
    }
  }

  async getCurrentReportsItemBySlug(slug, lang) {
    try {
      const items = await CurrentReportsService.getCurrentReportsItemBySlug(
        slug,
        lang
      );
      return items.isEmpty ? null : items.items[0];
    } catch (e) {
      console.error('Failed to fetch current reports news item data by slug');
      return null;
    }
  }
}

decorate(CurrentReportsStore, {
  searches: observable,
  otherCurrentReports: observable,
  fetchArticles: action
});

export default new CurrentReportsStore();



// WEBPACK FOOTER //
// ./src/stores/CurrentReports.store.js